import {fetchOrders, fetchOrder, updateOrder, deleteOrder, updateMultipleStatus, getPart, getWatches} from '@/api'
import Vue from 'vue';
import router from "@/router";

const defaultFetch = { page: 1, force: false };

export default {
    namespaced: true,
    state: {
        paginated: {
            current: 1,
            data: [],
            total: 1,
            pageSize: 10,
            showQuickJumper: true
        },
        isLoading: false,
        order: {},
        emailModalVisible: false,
        search: {
            type: '',
            content: ''
        },
    },
    mutations: {
        SET_PAGINATED_ORDERS: (state, paginated) => state.paginated = paginated,
        SET_ORDER: (state, order) => state.order = order,
        SET_LOADING: (state) => state.isLoading = !state.isLoading,
        SET_EMAIL_MESSAGE_VISIBLE: state => state.emailModalVisible = !state.emailModalVisible,
        SET_SEARCH: (state, search) => state.search = search
    },
    actions: {
        fetchOrders({ commit, state }, { page, force, sorter = null, ...rest } = defaultFetch) {
            if (force || !state.paginated.data.length) {
                commit('SET_LOADING')

                let query = {};

                if (sorter !== null && Object.keys(sorter).length > 0) {
                    let prefix = 'parts';
                    query = { sort: sorter.field, dord: sorter.order === 'ascend' ? 'asc' : 'desc' };
                }

                return fetchOrders(page, {...query, ...rest})
                    .then(res => {
                        commit('SET_LOADING')
                        commit('SET_PAGINATED_ORDERS', {
                            ...res.data,
                            current: res.data.current_page,
                            pageSize: res.data.per_page,
                            data: res.data.data
                        })
                        return res
                    }).catch(() => commit('SET_LOADING'))
            }
        },

        fetchOrder({ commit, state }, { order, id, force = false }) {
            if (order) {
                commit('SET_ORDER', order)
            } else if (!Object.keys(state.order).length && id) {
                commit('SET_LOADING')
                fetchOrder(id).then(res => {
                    commit('SET_LOADING')
                    commit('SET_ORDER', res.data)
                }).catch(() => commit('SET_LOADING'))
            }
        },

        updateOrder({ dispatch, commit }, { id, order }) {
            updateOrder(id, order).then(() => {
                dispatch('fetchOrders', {...defaultFetch, force: true})
                commit('SET_EMAIL_MESSAGE_VISIBLE')
            })
        },

        deleteOrder({ dispatch }, id) {
            deleteOrder(id).then(() => dispatch('fetchOrders', {...defaultFetch, force: true}))
        },

        updateMultipleOrdersStatus({ dispatch, state, commit }, selection) {
            updateMultipleStatus(selection)
                .then(() => {
                    dispatch('fetchOrders', { force: true, page: state.paginated.current || 1 })
                    commit('SET_EMAIL_MESSAGE_VISIBLE')
                }).catch(err => console.log(`ERROR`, err))
        },

        getOrder({ commit, dispatch }, { id, page, type }) {
            commit('SET_SEARCH', { type: type, content: id })
            if (!id) {
                return dispatch('fetch', {...defaultFetch, force: true})
            } else {
                commit('SET_LOADING')
                let query = []
                if (type === 'order') {
                    query = {
                        order: id
                    }
                } else {
                    query = {
                        client: id
                    }
                }

                return fetchOrders(page, query)
                    .then(res => {
                        commit('SET_PAGINATED_ORDERS', {
                            ...res.data,
                            current: res.data.current_page,
                            pageSize: res.data.per_page,
                            data: res.data.data
                        })

                        router.replace({ query: { id, page, type } });
                    }).finally(() => commit('SET_LOADING'))
            }
        },
    },
    getters: {
        fields: (state, getters, rootState, rootGetters) => {
            const isAdmin = rootGetters['session/loggedUserIsAdmin']
            const lang = rootGetters.lang.orders.main_table

            const codeColmn = isAdmin
                ? { title: lang.by_name, dataIndex: 'user.name', key: 'by_name', sorter: true, scopedSlots: { customRender: 'by_name' } }
                : { title: lang.code, dataIndex: 'code', key: 'code', sorter: true, scopedSlots: { customRender: 'code' } }

            let fields = [
                { title: lang.number, dataIndex: 'id', key: 'number', width: '120px', sorter: true, scopedSlots: { customRender: 'number' }  },
                { title: lang.date, dataIndex: 'created_at', key: 'created_at', sorter: true, scopedSlots: { customRender: 'created_at' } },
                { title: lang.client_id, dataIndex: 'user.username', key: 'by_username', sorter: false, scopedSlots: { customRender: 'username' } },
                codeColmn,
                { title: lang.status, dataIndex: 'status', key: 'status', sorter: true, scopedSlots: { customRender: 'status' } },
            ];

            // Número Pedido, Fecha, ID Cliente, Nombre Cliente, eMail, Estado
            if (rootGetters['session/loggedUserIsAdmin']) {
                // fields.unshift({ title: '', dataIndex: 'id', key: 'selection', scopedSlots: { customRender: 'selection' } })
                fields.splice(4, 0, { title: lang.by, dataIndex: 'user.email', key: 'by', sorter: true, scopedSlots: { customRender: 'by' } })
            }

            fields.push({ title: lang.status_change, width: 140, dataIndex: 'id', align: 'center', key: 'status_change', scopedSlots: { customRender: 'status_change' } })

            return fields
        },
        order: state => ({
            ...state.order,
            items: state.order.items ? JSON.parse(state.order.items) : []
        }),
        color: () => code => {
            switch (parseInt(code)) {
                case 0: return "processing"
                case 1: return "success"
                case 2: return "default"
                case 3: return "error"
            }
        }
    }
}
